/* src/app/navigation/footer/footer.component.scss */
.footer {
  background-color: #3F51B5;
}
/*# sourceMappingURL=footer.component.css.map */
